// Dated delivery windows (11 Oct 2026; text scan added 13 Oct 2026).
// 1. Any element with data-dk-eta="from,to[,w]" becomes "between Sat 18 Oct and Sat 25 Oct",
//    counted from today; ",w" counts working days (Mon to Fri).
// 2. Theme-editor text (accordions, FAQs, section settings) cannot carry data attributes, so the
//    exact phrases "7 to 14 days later" and "3 to 5 working days later" in page text get the same
//    treatment. Without this script the page keeps its plain wording.
(() => {
  const fmt = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  const after = (days, working) => {
    const d = new Date();
    for (let n = 0; n < days; ) {
      d.setDate(d.getDate() + 1);
      if (!working || (d.getDay() !== 0 && d.getDay() !== 6)) n++;
    }
    return fmt.format(d);
  };
  const span = (from, to, working) => `between ${after(from, working)} and ${after(to, working)}`;
  const PHRASES = [
    [/7 to 14 days later/g, () => span(7, 14, false)],
    [/7 to 14 days after you order/g, () => span(7, 14, false)],
    [/3 to 5 working days later/g, () => span(3, 5, true)],
    [/3 to 5 working days after you order/g, () => span(3, 5, true)],
    [/3 to 5 days after you order/g, () => span(3, 5, true)],
    [/with you in 3 to 5 days/g, () => `with you ${span(3, 5, true)}`],
  ];
  const fill = () => {
    document.querySelectorAll('[data-dk-eta]:not([data-dk-eta-done])').forEach((el) => {
      const [from, to, w] = el.dataset.dkEta.split(',');
      el.textContent = span(+from, +to, w === 'w');
      el.setAttribute('data-dk-eta-done', '');
    });
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) =>
        /days (later|after you order)|in 3 to 5 days/.test(node.nodeValue) && node.parentElement && !node.parentElement.closest('script, style, [data-dk-eta]')
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT,
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      let text = node.nodeValue;
      PHRASES.forEach(([re, fn]) => {
        text = text.replace(re, fn());
      });
      if (text !== node.nodeValue) node.nodeValue = text;
    });
  };
  fill();
  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; fill(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
